<template>
  <div class="facebox card-content" :style="faceboxStyle">
    <div class="name" @click="selectEntity(entity)">
      <div>
        <div class="checkboxboxes" v-if="playerIsGM">
          <div class="input-field inline ">
            <input type="checkbox" name="inScenario" v-model="entity.inScenario" disabled="disabled">
            <span></span>
          </div>
          <div class="input-field inline">
            <input type="checkbox" name="isPresent" v-model="entity.isPresent" disabled="disabled">
            <span></span>
          </div>
        </div>
        <p>{{ entity.name }}</p>
      </div>
      
    </div>
    <span v-if="playerIsGM" class="btn-floating halfway-fab editButton">
      <router-link :to="{ name: 'EditEntity', params: {entity: entity} }">
      <i class="material-icons edit">edit</i>
      </router-link>
    </span>
    <i v-if="playerIsGM" class="material-icons btn-floating delete" @click="deleteEntity(entity)">delete</i>
  </div>
</template>

<script>
export default {
  name: 'EntityCard',
  props: [
    'entity',
    'selectEntity',
    'deleteEntity',
    'playerIsGM',
    ],
  computed: {
    faceboxStyle() {
      if (this.entity.name.toLowerCase().includes('azure')) return {'background-color': 'deepskyblue'}
      return {}
    },
  },
}
</script>

<style scoped>

.facebox{
  position: relative;
  background-color: green;
  width: 200px;
  height: 200px;
  margin: 20px 0px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.facebox:nth-child(1){background-color: tomato}
.facebox:nth-child(2){background-color: gold}
.facebox:nth-child(3){background-color: deepskyblue}
.name{
  font-size: 1.8em;
  text-align: center;
  color: white;

  width: 100%; height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  
}
/* Useful later when we have images
/* via https://stackoverflow.com/a/18322705/1302400
/* and https://jsfiddle.net/9z26ky19/
/**/
/*.image img {
    width:100%;
    vertical-align:top;
} */
.taken:after {
  content: '\A';
  position: absolute;
  width: 100%; height: 100%;
  top: 0; left: 0;
  background: rgba(0,0,0,0.6);
  opacity: 1;
  transition: all 0.5s;
  -webkit-transition: all 0.5s;
  pointer-events: none;
}
.card-content{
  cursor: pointer;
}
.delete{
  position: absolute;
  bottom: -20px;
  left: 140px;
  cursor: pointer;
  background: transparent;
  color: black;
  font-size: 2.6em;
}
.editButton{
  position: absolute;
  bottom: -20px;
  left: 25px;
  background: rgb(240, 118, 12);
}
.checkboxboxes{
  position: absolute;
  top: 10px;
  left: 65px;
  align-self: center;
}

</style>


// WEBPACK FOOTER //
// src/components/EntityCard.vue